import type { DailyOutcome } from "@highmarch/app";
import { fmtCompact } from "../kit";
import { rowHtml } from "../components";
import { emberGlyph, marksGlyph } from "../hub/eventRewards";
import { essenceIconHtml } from "../forgeArt";
import { paintedIconHtml } from "../featureIcons";

/** The painted lead of each row (CSS px). */
const LEAD_PX = 28;
const CHIP_PX = 14;

/**
 * The end screen's Daily Road block (MP-20, docs/MODES.md §4): the run's score against the day's best (NEW BEST
 * stamped), and what it paid — the day's reward on its first win, else that it was practice or that a win still pays.
 * A fact, never an offer.
 */
export function dailyEndHtml(o: DailyOutcome): string {
  const row = (kind: string, title: string, sub: string, end = ""): string => rowHtml({ lead: paintedIconHtml("dailyRoad", LEAD_PX), title, sub, end, compact: true, className: `erow ${kind}` });
  const r = o.record, best = r.entry?.score ?? o.score;
  const stamp = r.counted && r.newBest && r.previousBest !== null ? `<b class="enstamp disp">NEW BEST!</b>` : "";
  const p = o.paid;
  const chips = p ? `${p.essence > 0 ? `<small class="short ess">${essenceIconHtml(CHIP_PX)}+${fmtCompact(p.essence)}</small>` : ""}${p.marks > 0 ? `<small class="short">${marksGlyph(CHIP_PX)}+${fmtCompact(p.marks)}</small>` : ""}${o.embers > 0 ? `<small class="short">${emberGlyph(CHIP_PX)}+${o.embers}</small>` : ""}` : "";
  const paid = p
    ? row("daily paid", "REWARD", `Your first win today${o.event ? ` · embers to ${o.event.name}` : ""}`, chips)
    : o.dayPaid ? row(`daily${o.won ? "" : " lost"}`, "PRACTICE", "Today's reward is already yours")
      : row("daily lost", "NOT YET", "A win on today's road pays its reward");
  return `<div class="evend modeend dailyend stack">
    <div class="drscore">${stamp}<small>Daily Road · today's best</small><b class="disp">${fmtCompact(best)}</b></div>
    ${paid}
  </div>`;
}
